import { withTheme } from 'styled-components';

import { TariffDirection } from '../../../api/Optimise';
import type { Theme } from '../../../theme/themes/ThemeTypes';
import type { ChartDataItem } from '../../../types/charts';
import formatDate from '../../../utils/formatDate';
import textOrPlaceholder from '../../../utils/textOrPlaceholder';

import Chart from './Chart';
import Container from './Styled/Container';
import H3 from './Styled/H3';

interface ExportSavingsChartProps {
  chartData?: ChartDataItem[];
  date: string;
  hideTitle?: boolean;
  compact?: boolean;
  theme: Theme;
}

const ExportSavingsChart = ({ chartData, date, hideTitle, compact, theme }: ExportSavingsChartProps) => {
  const exportKey = 'actual_export_earning';

  const exportEarnings = chartData ? chartData.reduce((acc, row) => acc + row[exportKey], 0) / 100 : 0;

  const dataAvailable = chartData?.some((row) => row[exportKey] > 0);

  return (
    <Container $compact={compact}>
      {!hideTitle && (
        <H3 typeColour={theme.colors.exported}>
          Grid <span className="type">export</span> earnings on {formatDate(date)}:{' '}
          <span className="cost">£{textOrPlaceholder(exportEarnings, exportEarnings?.toFixed(2))}</span>
        </H3>
      )}
      {/* @ts-ignore */}
      <Chart
        data={chartData}
        dataKey={exportKey}
        barColor={theme.colors.exported}
        yAxisLabel="Export earnings"
        xAxisLabel="Time of day"
        dataAvailable={dataAvailable}
        direction={(TariffDirection as any).EXPORT}
      />
    </Container>
  );
};

export default withTheme(ExportSavingsChart);
